exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-glyphicon {\n  vertical-align: middle;\n  top: 0;\n  line-height: inherit;\n}\n.uu5-bricks-button .glyphicon,\n.uu5-bricks-button .uu5-bricks-glyphicon {\n  font-size: 0.85em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/glyphicon.less
// module id = 214
// module chunks = 0